import React, { useState, useRef, useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { ArrowLeftOutlined, UploadOutlined } from '@ant-design/icons'
import { Modal, Avatar, Space, Input, Button, Select, Upload, message, Typography, Table, Popconfirm, Spin, InputNumber, DatePicker } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'
import axios from 'axios'

const styleVideo = {
  width: 300,
  height: 'auto',
  objectFit: 'cover',
  marginRight: '10px',
}

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline'], // formatting options // ? Make sure supported at UI
  ],
}

function CreateSection() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const getStartedItemId = searchParams.get('getStartedItemId')
  const [getStartedData, setGetStartedData] = useState([])
  const [removedAttachmentNames, setRemovedAttachmentNames] = useState([]) // During edit its required

  const auth = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false)

  const [form, setForm] = useState({
    title: '',
    attachments: [],
  })

  // Text input field
  const onChange = (obj) => {
    // console.log(obj)
    setForm((prev) => ({ ...prev, ...obj }))
  }

  const onVideoDescriptionChange = (obj) => {
    const modifiedAttachments = form.attachments.map((el) => {
      if (el.uid == obj.uid) {
        return {
          ...el,
          givenDescription: obj.description,
        }
      } else return el
    })
    setForm((prevForm) => {
      return {
        ...prevForm,
        attachments: modifiedAttachments,
      }
    })
  }

  const beforeUploadPictureUpload = (file) => {
    const isImage = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'

    const isVideo =
      file.type === 'video/mp4' ||
      file.type === 'video/quicktime' || // .mov
      file.type === 'video/webm'

    if (!isImage && !isVideo) {
      message.error(`${file.name} is not a supported file type. Please upload JPEG, PNG, MP4, MOV, or WEBM.`)
      return Upload.LIST_IGNORE
    }

    const maxSizeMB = isImage ? 5 : 500
    const isWithinLimit = file.size / 1024 / 1024 < maxSizeMB

    if (!isWithinLimit) {
      message.error(`${file.name} must be smaller than ${maxSizeMB}MB!`)
      return Upload.LIST_IGNORE
    }

    // Prevent auto-upload, but still add to fileList
    return false
  }

  const createGetStartedSeaction = async () => {
    try {
      setLoading(true)
      console.log(form)

      if (!form.title) {
        alert("Title can't be empty!")
        setLoading(false)
        return
      }

      const fmData = new FormData()

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: `Bearer ${auth.token}`,
        },
      }

      fmData.append('title', form.title)

      form.attachments.forEach((element) => {
        fmData.append('attachments', element.originFileObj)
      })

      const attachmentDescriptions = form.attachments.map((el) => {
        // console.log(el)
        return {
          name: el.name,
          givenDescription: el.givenDescription,
          type: el.type,
        }
      })

      fmData.append('attachmentDescriptions', JSON.stringify(attachmentDescriptions))

      // return

      const res = await axios
        .post(`${process.env.REACT_APP_BASE_URL}/api/v1/appInputs/createNewGetStartedSection`, fmData, config)
        .then((res) => {
          // console.log(res.data)
          navigate(-1)
          setLoading(false)
        })
        .catch((err) => {
          console.log('error axios', err)
          setLoading(false)
        })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const editGetStartedSeaction = async () => {
    try {
      setLoading(true)
      console.log(form)

      if (!form.title) {
        alert("Title can't be empty!")
        setLoading(false)
        return
      }

      const fmData = new FormData()

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: `Bearer ${auth.token}`,
        },
      }

      fmData.append('title', form.title)

      form.attachments.forEach((element) => {
        // Because some could be old editable items which doesn't contain originFileObj
        if (element.originFileObj) {
          fmData.append('attachments', element.originFileObj)
        }
      })

      const attachmentDescriptions = form.attachments
        .map((el) => {
          if (el.originFileObj) {
            return {
              name: el.name,
              givenDescription: el.givenDescription,
              type: el.type,
            }
          } else {
            return {
              name: el.originalname, // beacuse after attachment already updated, the name stored as 'originalname' at db, so need to send this like this, to make sure 'givenDescription' is editable
              givenDescription: el.givenDescription,
              type: el.type,
            }
          }
          return null // fallback, no need anymore
        })
        .filter((el) => el !== null)

      fmData.append('attachmentDescriptions', JSON.stringify(attachmentDescriptions))
      fmData.append('removedAttachmentNames', JSON.stringify(removedAttachmentNames))

      for (let pair of fmData.entries()) {
        console.log(`${pair[0]}:`, pair[1])
      }

      // return

      const res = await axios
        .put(`${process.env.REACT_APP_BASE_URL}/api/v1/appInputs/editGetStartedSection?docId=${getStartedItemId}`, fmData, config)
        .then((res) => {
          // console.log(res.data)
          navigate(-1)
          setLoading(false)
        })
        .catch((err) => {
          console.log('error axios', err)
          setLoading(false)
        })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const getData = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(`/api/v1/appInputs/getGetStartedData`)
      setGetStartedData(response.data.getStartedData)

      const theEditableOne = response.data.getStartedData.filter((elem) => elem._id == getStartedItemId)
      console.log(theEditableOne)
      if (theEditableOne.length) setForm(theEditableOne[0])

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const deleteGetStartedData = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.delete(`/api/v1/appInputs/deleteGetStartedSection?docId=${getStartedItemId}`)
      navigate(-1)

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    console.log(form)
  }, [form])

  return (
    <Layout>
      <ArrowLeftOutlined
        Video={{
          color: '#1677ff',
          fontSize: '1.5rem',
          marginBottom: 20,
          cursor: 'pointer',
        }}
        onClick={() => navigate(-1)}
      />
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <div>
          <p>Create a new section at Get Started page</p>
        </div>
        <Input placeholder="Title" value={form.title} style={{ marginBottom: 10 }} onChange={(e) => onChange({ title: e.target.value })} />
        <Upload.Dragger
          // style={{ height: 100 }}
          name="logo"
          listType="picture"
          maxCount={10}
          // customRequest={uploadProfilePicture} // Don't use this function immediately after something gets selected
          beforeUpload={beforeUploadPictureUpload}
          onChange={({ fileList }) => {
            const missingInVideo2 = form.attachments.filter((v1) => !fileList.some((v2) => v2.name === v1.name)) // This is to find out the "name" of the video
            if (missingInVideo2.length) {
              setRemovedAttachmentNames((prev) => [...prev, missingInVideo2[0]?.name]) // to send at backend
            }

            setForm((prevForm) => {
              return {
                ...prevForm,
                attachments: fileList,
              }
            })
          }}
          fileList={form.attachments}
          accept="image/jpeg,image/jpg,image/png,video/mp4,video/quicktime,video/webm"
        >
          <Button type="text" icon={<UploadOutlined />}>
            Click to upload or drag here
          </Button>
        </Upload.Dragger>

        {form.attachments.map((el, idx) => {
          return (
            <div key={idx} style={{ border: '1px solid #c4c4c4' }}>
              {el.mediaLink && <img src={el.mediaLink} alt="." style={{ width: 300, height: 300, objectFit: 'contain' }} />}
              <ReactQuill
                modules={modules}
                theme="snow"
                placeholder={`Description for ${el.name}`}
                defaultValue={el.givenDescription}
                onChange={(value) => {
                  onVideoDescriptionChange({ uid: el.uid, description: value })
                }}
              />
            </div>
          )
        })}

        {loading && <Spin size="large" />}
        {getStartedItemId && (
          <Popconfirm title="Are you sure to delete this?" description="Its can't be undone." onConfirm={deleteGetStartedData} onCancel={() => {}} okText="Yes" cancelText="No">
            <Button type="primary" danger ghost disabled={loading}>
              Delete Permanently
            </Button>
          </Popconfirm>
        )}
        <Button
          type="primary"
          disabled={loading}
          onClick={() => {
            if (!getStartedItemId) {
              createGetStartedSeaction()
            } else {
              editGetStartedSeaction()
            }
          }}
        >
          {!getStartedItemId ? 'Create' : 'Save edit'}
        </Button>
      </Space>
    </Layout>
  )
}

export default CreateSection
